/* bus.js — event-bus över window.
 *
 * Cross-modul-kommunikation utan import-cycles. ALLA events prefix:as 'mm:'.
 *
 * Pattern:
 *   import { emit, on } from './bus.js';
 *   emit('kommun-selected', { kod: '0114' });
 *   on('kommun-selected', ({ kod }) => console.log('Vald:', kod));
 *
 * För att unsubscribe: spara return-värdet från on() och anropa det.
 *   const off = on('foo', handler);
 *   off();
 */

const PREFIX = 'mm:';

export function emit(event, detail) {
    window.dispatchEvent(new CustomEvent(PREFIX + event, { detail }));
}

export function on(event, handler) {
    const cb = (e) => handler(e.detail);
    window.addEventListener(PREFIX + event, cb);
    return () => window.removeEventListener(PREFIX + event, cb);
}

// once: lyssna en gång och unhook automatiskt
export function once(event, handler) {
    const off = on(event, (detail) => {
        off();
        handler(detail);
    });
    return off;
}
